var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      [
        _vm.isPage == 0 ? _c("bstep0") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 1 ? _c("bstep1") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 2 ? _c("bstep2") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 3 ? _c("bstep3") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 4 ? _c("bstep4") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 5 ? _c("bstep5") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 6 ? _c("bstep6") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 7 ? _c("gstep2") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 8 ? _c("gstep4") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 9 ? _c("gstep5") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 10 ? _c("gstep6") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 11 ? _c("gstep7") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 12 ? _c("gstep8") : _vm._e(),
        _vm._v(" "),
        _vm.isPage == 13 ? _c("personal-detail") : _vm._e()
      ],
      _vm._v(" "),
      _c("div", { staticClass: "row my-3" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" },
          [
            _c("progress-step", {
              attrs: { page: _vm.isPage },
              on: {
                "next-page": _vm.nextPage,
                "back-page": _vm.backPage,
                "submit-btn": _vm.submitDetail
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7169a913", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7169a913","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/index.vue
// module id = 2315
// module chunks = 0